















































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeComorbidadesStore from '@/components/Backoffice/Store/BackofficeComorbidadeStore'
import { ComorbidadeProps } from '@/types/interfaces/Comorbidades'
import { permissionService } from '@/services/permission.service'
import useHospitais from '@/composables/useHospitais/useHospitais'

@Component
export default class ViewBackofficeComorbidades extends Vue {
  searchComorbidade = ''
  comorbidadesLoading = false
  get getBackofficeComorbidades() {
    return getModule(BackofficeComorbidadesStore, this.$store)
  }

  statusLabel = {
    Ativo: 'Ativo',
    Removido: 'Inativo',
  }

  get hospitaisList() {
    return useHospitais.hospitaisByCurrentUser
  }

  async fetchHospitaisList() {
    await useHospitais.loadHospitaisByCurrentUser()
  }

  get hospitalId() {
    return this.getBackofficeComorbidades.hospitalId
  }

  set hospitalId(value: string) {
    this.getBackofficeComorbidades.setHospitalId(value)
  }

  get canComorbidadeAction() {
    return permissionService.hasPermission(
      'agendamento.backoffice.comorbidadeHospital.alterar',
    )
  }

  get comorbidadesHeaders() {
    return [
      { text: 'Descrição', value: 'descricao', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get comorbidadesList() {
    return this.getBackofficeComorbidades.comorbidades
  }

  async hospitalChange(id: any) {
    this.comorbidadesLoading = true
    this.searchComorbidade = ''
    this.getBackofficeComorbidades.setHospitalId(id)
    await this.getBackofficeComorbidades.getComorbidadesByHospitalId()
    this.comorbidadesLoading = false
  }

  editComorbidade(item: ComorbidadeProps) {
    this.getBackofficeComorbidades.setModal({ isOpen: true, mode: 'EDIT' })
    this.getBackofficeComorbidades.setComorbidadeSelected(item)
  }

  createComorbidade() {
    this.getBackofficeComorbidades.setModal({ isOpen: true, mode: 'CREATE' })
  }

  beforeDestroy() {
    this.getBackofficeComorbidades.clearHospitalId()
  }
}
